import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { isCorpTenant } from "@capone/common";
import { IStoreState } from "../../../../reducers/types";
import {
  getSelectedAccount,
  getSelectedAccountReferenceIdIfRedemptionEnabled,
  getUserIsPrimaryCardHolder,
} from "../../../rewards/reducer";
import { getDepartureDate, getReturnDate } from "../../../search/reducer";
import {
  getHotelShopCallState,
  getHotelShopChosenProduct,
  getHotelShopChosenProductIndex,
  getHotelShopChosenRoomInfo,
  getHotelShopChosenRoomInfoIndex,
  getPackageLodgingRoomInfoProducts,
  getPackageRatesById,
  getPackageSelectedLodging,
} from "../../reducer";
import { MobileRoomPicker } from "./component";
import { actions } from "../../actions";
import { config } from "../../../../api/config";
import {
  getPackageNightCountBasedOnAvailability,
  getTravelersCount,
} from "../../../availability/reducer";
import { PackageHotelShopCallState } from "../../reducer/state";

const mapStateToProps = (state: IStoreState) => ({
  checkinDate: getDepartureDate(state),
  checkoutDate: getReturnDate(state),
  roomInfoProducts: getPackageLodgingRoomInfoProducts(state),
  chosenRoomInfoIndex: getHotelShopChosenRoomInfoIndex(state),
  chosenRoomInfo: getHotelShopChosenRoomInfo(state),
  chosenProductIndex: getHotelShopChosenProductIndex(state),
  chosenProduct: getHotelShopChosenProduct(state),
  selectedLodging: getPackageSelectedLodging(state),
  nightCount: getPackageNightCountBasedOnAvailability(state),
  rewardsKey:
    getSelectedAccountReferenceIdIfRedemptionEnabled(state) ?? undefined,

  canEarnRewards:
    !isCorpTenant(config.TENANT) || getUserIsPrimaryCardHolder(state),
  packagesByRateId: getPackageRatesById(state),
  travelersCount: getTravelersCount(state),
  isHotelShopLoading:
    getHotelShopCallState(state) === PackageHotelShopCallState.InProcess,
  selectedAccount: getSelectedAccount(state),
});

export const mapDispatchToProps = {
  selectRoomType: actions.selectRoomType,
  // fetchHotelShop: actions.fetchHotelShop,
  setSelectedRoomId: actions.setSelectedRoomId,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileRoomPickerConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedMobileRoomPicker = withRouter(
  connector(MobileRoomPicker),
);
